import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function Protected({ Cmp }) {
  const navigate = useNavigate();
  let userData = sessionStorage.getItem("token");
  const location = useLocation();
  const path = location.pathname;

  const publicPaths = ["/privacy-policy", "/terms", "/about", "/contact", "/refund-policy"];

  useEffect(() => {
    if (!userData && !publicPaths.includes(path)) {
      navigate("/login");
    }
  }, [navigate, userData, path]);

  return (
    <div>
      {Cmp && <Cmp />}
    </div>
  );
}
Protected.propTypes = {
  Cmp: PropTypes.func.isRequired,
};

export default Protected;
